import { localeFor } from "@/utils/formatters";

export const TIME_STEP = 30;

export const DEFAULT_RANGE = { startMinute: 1080, endMinute: 1320 };

export function formatMinute(
  m: number,
  lng: string,
  midnightLabel: string,
): string {
  if (m >= 1440) return midnightLabel;
  const h = Math.floor(m / 60);
  const mm = m % 60;
  const d = new Date(2000, 0, 1, h, mm);
  return new Intl.DateTimeFormat(localeFor(lng), {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(d);
}

export function getTimeOptions(
  lng: string,
  midnightLabel: string,
): Array<{ value: number; label: string }> {
  return Array.from({ length: 1440 / TIME_STEP + 1 }, (_, i) => {
    const value = i * TIME_STEP;
    return { value, label: formatMinute(value, lng, midnightLabel) };
  });
}

export function getWeekdaysShort(lng: string): Array<string> {
  const fmt = new Intl.DateTimeFormat(localeFor(lng), { weekday: "short" });
  // 2024-01-07 is a Sunday — index 0 in JS getDay().
  return Array.from({ length: 7 }, (_, i) => fmt.format(new Date(2024, 0, 7 + i)));
}

export function getMonthsLong(lng: string): Array<string> {
  const fmt = new Intl.DateTimeFormat(localeFor(lng), { month: "long" });
  return Array.from({ length: 12 }, (_, i) => fmt.format(new Date(2024, i, 1)));
}

export function getMonthsShort(lng: string): Array<string> {
  const fmt = new Intl.DateTimeFormat(localeFor(lng), { month: "short" });
  return Array.from({ length: 12 }, (_, i) => fmt.format(new Date(2024, i, 1)));
}
